const ASM_ERROR_FALLBACK = "asm.error";

/**
 * Resolves an ASM message code to display text. ASM error codes come from the backend (OOTB
 * exception `messageCode`s / flash attributes) and are only partially present in the React
 * translations. When a code has no translation — i18next returns the raw key — fall back to the
 * generic `asm.error` so the bar never renders a raw `asm.*` key string.
 */
export function resolveAsmMessage(t: (key: string) => string, code: string | undefined | null): string {
  if (!code) {
    return t(ASM_ERROR_FALLBACK);
  }
  const resolved = t(code);
  return resolved === code ? t(ASM_ERROR_FALLBACK) : resolved;
}
